import { useEffect } from 'react';

import nG1CommService from './nG1Comm.service';

/**
 * Public landing page for nG1 drill-down entry point.
 *
 * When nG1 opens nGP at /gotoPulse?tempTokenId=..., this page:
 *  1. Calls nG1CommService.connect() to register the message listener and send NSAVERIFYCALLBACK.
 *  2. Waits for nG1 to respond — nG1Comm.service.js will then redirect to /ipm/ng1/landing with
 *     the tempTokenId, completing authentication without a username/password prompt.
 *
 * This route must NOT be wrapped in AppSessionProvider so that unauthenticated nG1 users
 * are not redirected to the login page before the tempToken flow can complete.
 */
export default function GotoPulsePage() {
    useEffect(() => {
        nG1CommService(console).connect();
    }, []);

    return null;
}
